// extracted by mini-css-extract-plugin
export default {"Loader-wrapper":"loader_Loader-wrapper__Wx9l5","loader":"loader_loader__7TGy-","load":"loader_load__Gfjve"};